import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import CardExpand from '@/views/components/CardExpand.vue';
import { mdiEye, mdiPencil } from '@mdi/js';
import { IPareceres } from '../../types';
import { ConsultaParecerStore } from '@/views/parecer/store/ConsultaParecerStore';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import { storeToRefs } from 'pinia';

interface IProps {
  parecer?: IPareceres;
  isSelecionado: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardResultado',
  props: {
    parecer: null,
    isSelecionado: { type: Boolean }
  },
  emits: ['toggle-check'],
  setup(__props: any) {

const props = __props as {
  parecer?: IPareceres;
  isSelecionado: boolean;
};

const store = ConsultaParecerStore();
const { isPrivado } = storeToRefs(store);




const showDetalhes = ref(false);

const highlightedDesc = computed(() => props.parecer?.highlightedDesc || '');

const editarParecer = () => {
  if (props.parecer?.nuIdentificacao) {
    window.location.href = `/gecon/parecer/${props.parecer.nuIdentificacao}/editar?origem=consulta-avancada`;
  }
};

return { __sfc: true,store, isPrivado, props, showDetalhes, highlightedDesc, editarParecer, CardExpand, mdiEye, mdiPencil, mdiChevronDown, mdiChevronUp }
}

})